import { useState, useEffect } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  Typography,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Autocomplete,
  TextField,
  Box,
  Dialog,
  InputLabel,
  MenuItem,
  Select,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  createFollowUpRequest,
  getFollowUpRequest,
  updateFollowUpRequest,
} from '../../../redux/FollowUp/followupSlice';
import FollowupList from './FollowupList';
import { fetchInstalaxmiAdminRequest } from '../../../redux/Tickets/ticketSlice';
import {
  createJewellerRequest,
  resetCreatedJewellerId,
} from '../../../redux/JewellerList/JewellerSlice';
import { updateLeadRequest,
  createLeadRequest,
  getLeadByJewellerRequest,
  resetLeadByJeweller,
  resetCreatedLeadId,
 } from '../../../redux/Required/requiredSlice';

const CreateFollowup = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();

  const createdJewellerId = useSelector(
    (state) => state.jeweller.createdJewellerId,
  );
  const jewellerList = useSelector((state) => state.jeweller.jewellers);
  const { instalaxmiAdmin } = useSelector((state) => state.tickets);

  const leadByJeweller = useSelector((state) => state.lead?.leadByJeweller);
  const createdLeadId = useSelector((state) => state.lead?.createdLeadId);

  const [editData, setEditData] = useState(null);

  const { jewellerRow: selectedJeweller } = location.state || {};

  const navType = location.state?.type;
  const leadFromState = location.state?.lead;
  const jewellerRow = location.state?.jewellerRow;
  const jewellerIdFromState = location.state?.jewellerId;

  const [resolvedLead, setResolvedLead] = useState(leadFromState || null);

  const [pendingFollowup, setPendingFollowup] = useState(null);

  // contact name needed only when creating a brand-new lead from jeweller flow
  const [newLeadContactName, setNewLeadContactName] = useState('');

  const [selectedDate, setSelectedDate] = useState(null);
  const [value, setValue] = useState('');
  const [isCompleted, setIsCompleted] = useState('');
  const [comment, setComment] = useState('');
  const [notes, setNotes] = useState('');
  const [errors, setErrors] = useState({});

  const options = [
    'Intent Amount',
    'Documents Received',
    'Advance Amount Received',
    'Payment gateway Created',
    'Android App Created',
    'iOS App Created',
    'In-store branding delivered',
    'Training Scheduled',
    'Training Completed',
    'Full Payment received',
  ];

  const [jewellerData, setJewellerData] = useState({ RM: '' });
  const lead = location.state?.lead;
  console.log('Lead Data:', lead);
  const [openDialog, setOpenDialog] = useState(false);

  const [openJewellerDialog, setOpenJewellerDialog] = useState(false);
  const [jewellerFormData, setJewellerFormData] = useState({
    gst: '',
    package_name: '',
  });
  const [jewellerErrors, setJewellerErrors] = useState({});

  const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
  const jewellerID = storedUser?.jeweller;

  useEffect(() => {
    setResolvedLead(leadFromState || null);
    setPendingFollowup(null);
    setNewLeadContactName('');
    setEditData(null);
  }, [navType, jewellerIdFromState, leadFromState?._id]);

  useEffect(() => {
    dispatch(fetchInstalaxmiAdminRequest(jewellerID));
  }, [dispatch, jewellerID]);

  // if we came from the jeweller table without a lead, ask backend if one already exists
  useEffect(() => {
    if (navType === 'jeweller' && !leadFromState && jewellerIdFromState) {
      dispatch(getLeadByJewellerRequest(jewellerIdFromState));
    }
    return () => {
      dispatch(resetLeadByJeweller());
    };
  }, [navType, jewellerIdFromState]);

  useEffect(() => {
    if (navType === 'jeweller' && !leadFromState) {
      if (leadByJeweller) {
        setResolvedLead({
          ...leadByJeweller,
          phone: leadByJeweller.contactNumber || '',
          rm: (
            Array.isArray(leadByJeweller.assignedUser)
              ? leadByJeweller.assignedUser
              : leadByJeweller.assignedUser
              ? [leadByJeweller.assignedUser]
              : []
          )
            .map((user) => user?.name)
            .filter(Boolean)
            .join(', '),
          rmId: (
            Array.isArray(leadByJeweller.assignedUser)
              ? leadByJeweller.assignedUser
              : leadByJeweller.assignedUser
              ? [leadByJeweller.assignedUser]
              : Array.isArray(leadByJeweller.assignTo)
              ? leadByJeweller.assignTo
              : leadByJeweller.assignTo
              ? [leadByJeweller.assignTo]
              : []
          )
            .map((item) => (typeof item === 'string' ? item : item?._id))
            .filter(Boolean),
        });
      } else {
        setResolvedLead(null); 
      }
    }
  }, [leadByJeweller, navType, leadFromState]);

  const resetForm = () => {
    setEditData(null);
    setValue('');
    setComment('');
    setNotes('');
    setIsCompleted('');
    setSelectedDate(null);
    setJewellerData({ RM: '' });
    setNewLeadContactName('');
    setErrors({});
    setOpenDialog(false);
  };

  const resetJewellerForm = () => {
    setJewellerFormData({ gst: '', package_name: '' });
    setJewellerErrors({});
    setOpenJewellerDialog(false);
  };
  
  const effectiveLead = leadFromState || resolvedLead;
  const hasLead = !!effectiveLead?._id;

  // useEffect(() => {
  //   if (createdJewellerId && lead?._id) {
  //     dispatch(
  //       updateLeadRequest({
  //         id: lead._id,
  //         jeweller: createdJewellerId,
  //       }),
  //     );
  //     toast.success('Jeweller created and linked to lead!');
  //     dispatch(resetCreatedJewellerId());
  //   }
  // }, [createdJewellerId, lead?._id, dispatch]);

  useEffect(() => {
    if (createdLeadId && pendingFollowup) {
      dispatch(
        createFollowUpRequest({
          ...pendingFollowup,
          leadID: createdLeadId,
        }),
      );
      // toast.success('Lead and follow-up created successfully!');

      setResolvedLead({
        _id: createdLeadId,
        jewellerName: jewellerRow?.jewellerName || '',
        contactName: newLeadContactName,
        phone: jewellerRow?.phone || '',
        area: jewellerRow?.address?.[0]?.Area || '',
        city: jewellerRow?.address?.[0]?.city || '',
        state: jewellerRow?.address?.[0]?.state || '',
        pincode: jewellerRow?.address?.[0]?.pincode || '',
      });
      setPendingFollowup(null);
      dispatch(getFollowUpRequest(createdLeadId));
      dispatch(resetCreatedLeadId());
      resetForm();
    }
  }, [createdLeadId]);

  if (!effectiveLead && navType !== 'jeweller') {
    return (
      <Typography variant="h6" color="error">
        No lead data found. Please go back.
      </Typography>
    );
  }
  if (!effectiveLead && navType === 'jeweller' && !jewellerRow) {
    return (
      <Typography variant="h6" color="error">
        No jeweller data found. Please go back.
      </Typography>
    );
  }

  const handleChange = (event) => {
    setJewellerData((prev) => ({
      ...prev,
      RM: event.target.value,
    }));
  };

  // Validation
  const validateForm = () => {
    let tempErrors = {};

    if (!isCompleted) tempErrors.isCompleted = 'Please select a status';

    if (!editData) {
      if (!value?.trim()) tempErrors.value = 'Please enter a title';
      if (!jewellerData.RM) tempErrors.RM = 'Please select RM';
      if (!selectedDate) tempErrors.selectedDate = 'Please select a date';
      if (!hasLead && !newLeadContactName?.trim()) {
        tempErrors.newLeadContactName = 'Please enter a contact name';
      }
    }

    if (Object.keys(tempErrors).length > 0) {
      Object.values(tempErrors).forEach((msg) => toast.error(msg));
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSave = (e) => {
    e?.preventDefault?.();
    if (!validateForm()) return;

    const trimmedNotes = notes.trim();
    const trimmedComment = typeof comment === 'string' ? comment.trim() : '';

    if (editData?._id) {
      const updateData = {
        status: isCompleted,
      };
      if (trimmedComment) {
        updateData.comment = trimmedComment;
      }
      if (trimmedNotes) {
        updateData.Notes = trimmedNotes;
      }
      if (effectiveLead?._id) {
        updateData.leadID = effectiveLead._id;
      }
      dispatch(
        updateFollowUpRequest({ id: editData._id, data: updateData }),
      );
      toast.success('Follow-up updated successfully!');
      resetForm();
      return;
    }

    const followupPayload = {
      jewellerId: selectedJeweller?._id,
      assignTo: jewellerData.RM,
      status: isCompleted,
      followupDate: selectedDate?.toISOString(),
      title: value,
      type: navType === 'jeweller' ? 'jeweller' : 'lead',
    };
    if (trimmedComment) {
      followupPayload.comment = trimmedComment;
    }
    if (trimmedNotes) {
      followupPayload.Notes = trimmedNotes;
    }

    if (hasLead) {
      dispatch(
        createFollowUpRequest({ ...followupPayload, leadID: effectiveLead._id }),
      );
      toast.success('Follow-up created successfully!');
      resetForm();
      return;
    }
    
    // jeweller has no lead yet — create the lead first (jeweller set, leadId null),
    // then create the follow-up once we get the new lead's id back
    dispatch(
      createLeadRequest({
        id: null,
        type: 'jeweller',
        jeweller: jewellerIdFromState || jewellerRow?._id || null,
        jewellerName: jewellerRow?.jewellerName || '',
        countryCode: Array.isArray(jewellerRow?.countryCode)
          ? jewellerRow.countryCode[0]?._id
          : jewellerRow?.countryCode || '',
        contactName: newLeadContactName,
        contactNumber: jewellerRow?.phone || '',
        email: jewellerRow?.email || '',
        area: jewellerRow?.address?.[0]?.Area || '',
        state: jewellerRow?.address?.[0]?.state || '',
        city: jewellerRow?.address?.[0]?.city || '',
        pincode: jewellerRow?.address?.[0]?.pincode || '',
        assignTo: jewellerData.RM ? [jewellerData.RM] : [], 
      }),
    );

    setPendingFollowup(followupPayload);
  };

  const handleCreateJewellerConfirm = () => {
    const tempErrors = {};
    if (!jewellerFormData.gst?.trim())
      tempErrors.gst = 'GST Number is required';
    if (!jewellerFormData.package_name?.trim())
      tempErrors.package_name = 'Package Name (Android) is required';

    if (Object.keys(tempErrors).length > 0) {
      setJewellerErrors(tempErrors);
      Object.values(tempErrors).forEach((msg) => toast.error(msg));
      return;
    }

    const jewellerPayload = {
      jewellerName: effectiveLead?.jewellerName,
      email: effectiveLead?.email || '',
      phone: effectiveLead?.phone,
      countryCode: effectiveLead?.countryCode,
      identity: 'Gst',
      cluster: 'cluster-1',
      package_name: jewellerFormData.package_name,
      package_name_ios: '',
      address: [
        {
          address1: effectiveLead?.city || '',
          address2: effectiveLead?.address2 || '',
          address3: effectiveLead?.address3 || '',
          Area: effectiveLead?.area || '',
          city: effectiveLead?.city || '',
          state: effectiveLead?.state || '',
          pincode: effectiveLead?.pincode || '',
          gst: jewellerFormData.gst,
        },
      ],
      RM: Array.isArray(effectiveLead.rmId)
        ? effectiveLead.rmId
        : effectiveLead.rmId
        ? [effectiveLead.rmId]
        : [],
    };

    dispatch(createJewellerRequest(jewellerPayload));
    // toast.success('Jeweller creation request submitted!');
    resetJewellerForm();
  };

  const detailsTitle = hasLead ? 'Lead Details' : 'Jeweller Details';
  const detailsFields = hasLead
    ? [
        ['Jeweller Name', effectiveLead?.jewellerName],
        ['Contact Name', effectiveLead?.contactName],
        ['Phone', effectiveLead?.phone],
        ['RM', effectiveLead?.rm || '-'],
        ['Area', effectiveLead?.area || '-'],
        ['City', effectiveLead?.city || '-'],
        ['State', effectiveLead?.state || '-'],
        ['Pincode', effectiveLead?.pincode || '-'],
      ]
    : [
        ['Jeweller Name', jewellerRow?.jewellerName],
        ['Email', jewellerRow?.email],
        ['Phone', jewellerRow?.phone],
        [
        'RM',
        Array.isArray(jewellerRow?.RM) && jewellerRow.RM.length > 0
          ? jewellerRow.RM.map((rm) => rm.name).join(', ')   
          : '-',
      ],
        ['Area', jewellerRow?.address?.[0]?.Area || '-'],
        ['City', jewellerRow?.address?.[0]?.city || '-'],
        ['State', jewellerRow?.address?.[0]?.state || '-'],
        ['Pincode', jewellerRow?.address?.[0]?.pincode || '-'],
      ];

  return (
    <Card key={jewellerIdFromState || leadFromState?._id || 'none'} sx={{ margin: '80px auto', p: 3, width: '100%' }}>
      <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
        {/* Lead Details Card */}
        <Card sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: 2 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2,
            }}
          >
            <Typography fontWeight={700} fontSize={22} mb={2}>
              {detailsTitle}
            </Typography>
            {/* {!lead?.jeweller && (
              <Button
                variant="contained"
                sx={{
                  textTransform: 'none',
                  background:
                    'linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)',
                }}
                onClick={() => setOpenJewellerDialog(true)}
              >
                Convert Lead to Jeweller
              </Button>
            )} */}
          </Box>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
            {detailsFields.map(([label, val], idx) => (
              <Box key={idx} 
              sx={{ 
                width: '12.5%',
                minWidth: '150px',      
                wordBreak: 'break-word',
                pr: 1,
                mb: 1,
               }}>
                <Typography fontWeight={600}>{label}:</Typography>
                <Typography>{val}</Typography>
              </Box>
            ))}
          </Box>
          {!hasLead && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              No lead exists for this jeweller yet. Creating a follow-up below
              will also create the lead automatically.
            </Typography>
          )}
        </Card>

        {/* Buttons */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
          <Button
            variant="contained"
            sx={{
              width: { xs: '48%', sm: 'auto' },
              background: 'linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)',
            }}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>

          <Button
            variant="contained"
            sx={{
              width: { xs: '48%', sm: 'auto' },
              background: 'linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)',
            }}
            onClick={() => {
              resetForm();
              setOpenDialog(true);
            }}
          >
            Create Follow-up
          </Button>
        </Box>
      </CardContent>

      {/* Dialog Box */}
      <Dialog open={openDialog} onClose={resetForm} maxWidth="sm" fullWidth>
        <DialogTitle>
          {editData ? 'Edit Follow-up' : 'Create Follow-up'}
        </DialogTitle>
        <DialogContent>
          {!hasLead && (
            <TextField
              fullWidth
              size="small"
              sx={{ mt: 2 }}
              label="Contact Name"
              required
              value={newLeadContactName}
              onChange={(e) => setNewLeadContactName(e.target.value)}
              error={!!errors.newLeadContactName}
              helperText={errors.newLeadContactName}
            />
          )}
          {/* Autocomplete Title */}
          <Autocomplete
            disabled={!!editData}
            sx={{ width: '100%', mt: 2 }}
            freeSolo
            options={options}
            size="small"
            value={value}
            onChange={(event, newValue) => setValue(newValue)}
            onInputChange={(event, newInputValue) => setValue(newInputValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select or type"
                variant="outlined"
                error={!!errors.value}
                helperText={errors.value}
              />
            )}
          />

          {/* RM Selection */}
          <FormControl
            fullWidth
            size="small"
            sx={{ mt: 2 }}
            error={!!errors.RM}
          >
            <InputLabel id="instalaxmi-user-label">
              RM <span style={{ color: 'red' }}>*</span>
            </InputLabel>
            <Select
              disabled={!!editData}
              labelId="instalaxmi-user-label"
              name="RM"
              value={jewellerData.RM || ''}
              onChange={handleChange}
            >
              {instalaxmiAdmin.map((user) => (
                <MenuItem key={user._id} value={user._id}>
                  {user.name}
                </MenuItem>
              ))}
            </Select>
            {errors.RM && (
              <Typography color="error" variant="caption">
                {errors.RM}
              </Typography>
            )}
          </FormControl>

          {/* Comment Field — plain optional string; update replaces this value */}
          <TextField
            fullWidth
            label="Comment"
            placeholder="Add a comment (optional)"
            variant="outlined"
            multiline
            rows={3}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            error={!!errors.comment}
            helperText={errors.comment}
            sx={{ mt: 2 }}
            disabled={!!editData}
          />

          <TextField
            fullWidth
            label={editData ? 'Add Note' : 'Notes'}
            placeholder="Add a note (optional)"
            variant="outlined"
            multiline
            rows={3}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            sx={{ mt: 2 }}
          />

          {/* Date Picker */}
          <Box sx={{ mt: 2 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                disabled={!!editData}
                label="Follow-up Date"
                value={selectedDate}
                disablePast
                minDate={dayjs()}
                onChange={(newValue) => setSelectedDate(newValue)}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: 'small',
                    error: !!errors.selectedDate,
                    helperText: errors.selectedDate,
                  },
                }}
              />
            </LocalizationProvider>
          </Box>

          {/* Status Radio Buttons */}
          <FormControl component="fieldset" sx={{ mt: 2 }}>
            <FormLabel>Status ?</FormLabel>
            <RadioGroup
              row
              value={isCompleted}
              onChange={(e) => setIsCompleted(e.target.value)}
            >
              <FormControlLabel
                value="created"
                control={<Radio />}
                label="Created"
              />
              <FormControlLabel
                value="completed"
                control={<Radio />}
                label="Completed"
              />
              <FormControlLabel
                value="in-progress"
                control={<Radio />}
                label="In-progress"
              />
              <FormControlLabel value="hold" control={<Radio />} label="Hold" />
              <FormControlLabel
                value="closed"
                control={<Radio />}
                label="Closed"
              />
            </RadioGroup>
            {errors.isCompleted && (
              <Typography color="error" variant="caption">
                {errors.isCompleted}
              </Typography>
            )}
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            type="button"
            onClick={resetForm}
            sx={{
              textTransform: 'none',
              background: 'linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)',
              WebkitBackgroundClip: 'text',
              fontWeight: '700',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleSave}
            variant="contained"
            sx={{
              textTransform: 'none',
              background: 'linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)',
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openJewellerDialog}
        onClose={resetJewellerForm}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Create Jeweller</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Please confirm the required details below to create a jeweller for
            this lead.
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', width: '100%', mb: 2 }}>
            {[
              ['Jeweller Name', effectiveLead?.jewellerName],
              ['Contact Name', effectiveLead?.contactName],
              ['Phone', effectiveLead?.phone],
              ['Area', effectiveLead?.area || '-'],
              ['City', effectiveLead?.city || '-'],
              ['State', effectiveLead?.state || '-'],
              ['Pincode', effectiveLead?.pincode || '-'],
            ].map(([label, val], idx) => (
              <Box key={idx} sx={{ width: '50%', mb: 1 }}>
                <Typography fontWeight={600} component="span">
                  {label}:{' '}
                </Typography>
                <Typography component="span">{val}</Typography>
              </Box>
            ))}
          </Box>
          <TextField
            fullWidth
            size="small"
            label="GST Number"
            required
            value={jewellerFormData.gst}
            onChange={(e) =>
              setJewellerFormData((prev) => ({ ...prev, gst: e.target.value }))
            }
            error={!!jewellerErrors.gst}
            helperText={jewellerErrors.gst}
            sx={{ mt: 1 }}
          />
          <TextField
            fullWidth
            size="small"
            label="Package Name (Android)"
            required
            value={jewellerFormData.package_name}
            onChange={(e) =>
              setJewellerFormData((prev) => ({
                ...prev,
                package_name: e.target.value,
              }))
            }
            error={!!jewellerErrors.package_name}
            helperText={jewellerErrors.package_name}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            type="button"
            onClick={resetJewellerForm}
            sx={{
              textTransform: 'none',
              background: 'linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)',
              WebkitBackgroundClip: 'text',
              fontWeight: '700',
              WebkitTextFillColor: 'transparent',
            }}
          >
            No
          </Button>
          <Button
            type="button"
            variant="contained"
            onClick={handleCreateJewellerConfirm}
            sx={{
              textTransform: 'none',
              background: 'linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)',
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Follow-up List */}
      <CardContent>
        <FollowupList
          leadID={effectiveLead?._id}
          jewellerID={selectedJeweller?._id}
          onEdit={(item) => {
            setEditData(item);
            setValue(item.title);
            setComment(
              typeof item.comment === 'string'
                ? item.comment
                : item?.comment?.[0]?.comment || '',
            );
            setNotes('');
            setIsCompleted(item.status);
            const followupDateValue = item.followupDate
              ? dayjs(
                  typeof item.followupDate === 'number'
                    ? item.followupDate
                    : Number(item.followupDate) || item.followupDate,
                )
              : null;
            setSelectedDate(
              followupDateValue?.isValid() ? followupDateValue : null,
            );
            setJewellerData({
              RM: item.assignTo?._id || item.assignTo || '',
            });
            setOpenDialog(true);
          }}
        />
      </CardContent>
    </Card>
  );
};

export default CreateFollowup;
